import GrowegyLogo from '../assets/images/growegy-logo.png';
import React, { PropsWithChildren } from 'react';

export const SplashScreen = (props: PropsWithChildren) => (
  <div className="app-splash-screen__container">
    <img src={GrowegyLogo} alt="Growegy logo" />
    <div className="growegy-spinner__wrapper--big">{props.children}</div>
  </div>
);
